class createSmsTemplate {
    constructor($injector) {
        this.state = $injector.get('$state');
        this.translate = $injector.get('$translate');
        this.modal = $injector.get('$uibModal');

        this.key = 'create-template';
        this.title = this.translate.instant('messages.workflows.sms-template-list.create-template.title');
        this.level = 'highlight';
        this.icon = 'fal fa-plus-circle';
    }

    action(payload, store) {
        this.state.go('app.messages.sms.templates.create');
    }

}

angular
    .module('festzelt-os.modules.messages')
    .factory('createSmsTemplate', [
        '$injector',
        ($injector) => new createSmsTemplate($injector)
    ]);



// WEBPACK FOOTER //
// ./src/app/modules/messages/workflows/sms-template-list/create-template.js